import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_217e657c from 'nuxt_plugin_plugin_217e657c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_77e616c1 from 'nuxt_plugin_bootstrapvue_77e616c1' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_templatesplugin5441d929_420649ac from 'nuxt_plugin_templatesplugin5441d929_420649ac' // Source: ./templates.plugin.5441d929.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_a0d3b38c from 'nuxt_plugin_cookieuniversalnuxt_a0d3b38c' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_4cbab9e9 from 'nuxt_plugin_pluginutils_4cbab9e9' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_0282137d from 'nuxt_plugin_pluginseo_0282137d' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_82171e18 from 'nuxt_plugin_pluginrouting_82171e18' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_094f3efb from 'nuxt_plugin_pluginmain_094f3efb' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_templatesplugin4f321f1e_d201a5b0 from 'nuxt_plugin_templatesplugin4f321f1e_d201a5b0' // Source: ./templates.plugin.4f321f1e.js (mode: 'all')
import nuxt_plugin_nuxtenv_344ca3f4 from 'nuxt_plugin_nuxtenv_344ca3f4' // Source: ./nuxt-env (mode: 'all')
import nuxt_plugin_nuxtsentryclient_244aa637 from 'nuxt_plugin_nuxtsentryclient_244aa637' // Source: ./nuxt-sentry-client.js (mode: 'client')
import nuxt_plugin_toast_3f003741 from 'nuxt_plugin_toast_3f003741' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_72cfea92 from 'nuxt_plugin_axios_72cfea92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_06e3a430 from 'nuxt_plugin_gtm_06e3a430' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_deviceplugin_64e4d01d from 'nuxt_plugin_deviceplugin_64e4d01d' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_ff5ff9a4 from 'nuxt_plugin_workbox_ff5ff9a4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_63423c41 from 'nuxt_plugin_metaplugin_63423c41' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_moment_144e0d74 from 'nuxt_plugin_moment_144e0d74' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_datepicker_0c042044 from 'nuxt_plugin_datepicker_0c042044' // Source: ../plugins/datepicker.js (mode: 'client')
import nuxt_plugin_lightGalleryclient_235dd9a0 from 'nuxt_plugin_lightGalleryclient_235dd9a0' // Source: ../plugins/lightGallery.client.js (mode: 'client')
import nuxt_plugin_cartState_10e8b97c from 'nuxt_plugin_cartState_10e8b97c' // Source: ../plugins/cartState.js (mode: 'client')
import nuxt_plugin_persistedState_1da1c1a3 from 'nuxt_plugin_persistedState_1da1c1a3' // Source: ../plugins/persistedState.js (mode: 'all')
import nuxt_plugin_filter_3b4804c9 from 'nuxt_plugin_filter_3b4804c9' // Source: ../plugins/filter.js (mode: 'all')
import nuxt_plugin_vuetouch_737c6982 from 'nuxt_plugin_vuetouch_737c6982' // Source: ../plugins/vue-touch (mode: 'client')
import nuxt_plugin_pusher_4253ec9a from 'nuxt_plugin_pusher_4253ec9a' // Source: ../plugins/pusher.js (mode: 'client')
import nuxt_plugin_plugin_354d424e from 'nuxt_plugin_plugin_354d424e' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_authredirect_4c47342c from 'nuxt_plugin_authredirect_4c47342c' // Source: ../plugins/auth-redirect.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"JaFun 從伴手禮來傳達日本文化及魅力","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"},{"name":"facebook-domain-verification","content":"mgssmtcl8ycekd8px6uimipcgjomy1"},{"hid":"description","name":"description","content":"全台最大的日本伴手禮商城，你可以找到日本當地才有的伴手禮，深入走進日本在地生活，吃到最道地的日本美食。"},{"hid":"og:site_name","property":"og:site_name","content":"JaFun 從伴手禮來傳達日本文化及魅力"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fdev.jafun.com.tw"},{"hid":"og:title","property":"og:title","content":"JaFun 從伴手禮來傳達日本文化及魅力"},{"hid":"og:description","property":"og:description","content":"全台最大的日本伴手禮商城，你可以找到日本當地才有的伴手禮，深入走進日本在地生活，吃到最道地的日本美食。"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"favicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Open+Sans:300,400,600,700"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Noto+Sans+JP:wght@400;500;700;900&family=Noto+Sans+TC:wght@400;500;700;900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.fontawesome.com\u002Freleases\u002Fv5.6.3\u002Fcss\u002Fall.css","integrity":"sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s\u002F","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fstarability\u002F2.4.2\u002Fstarability-minified\u002Fstarability-all.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fanimate.css\u002F4.1.1\u002Fanimate.min.css"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5XJ4J98')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5XJ4J98&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_217e657c === 'function') {
    await nuxt_plugin_plugin_217e657c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_77e616c1 === 'function') {
    await nuxt_plugin_bootstrapvue_77e616c1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin5441d929_420649ac === 'function') {
    await nuxt_plugin_templatesplugin5441d929_420649ac(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_a0d3b38c === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_a0d3b38c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_4cbab9e9 === 'function') {
    await nuxt_plugin_pluginutils_4cbab9e9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_0282137d === 'function') {
    await nuxt_plugin_pluginseo_0282137d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_82171e18 === 'function') {
    await nuxt_plugin_pluginrouting_82171e18(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_094f3efb === 'function') {
    await nuxt_plugin_pluginmain_094f3efb(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin4f321f1e_d201a5b0 === 'function') {
    await nuxt_plugin_templatesplugin4f321f1e_d201a5b0(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtenv_344ca3f4 === 'function') {
    await nuxt_plugin_nuxtenv_344ca3f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtsentryclient_244aa637 === 'function') {
    await nuxt_plugin_nuxtsentryclient_244aa637(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_3f003741 === 'function') {
    await nuxt_plugin_toast_3f003741(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_72cfea92 === 'function') {
    await nuxt_plugin_axios_72cfea92(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_06e3a430 === 'function') {
    await nuxt_plugin_gtm_06e3a430(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_64e4d01d === 'function') {
    await nuxt_plugin_deviceplugin_64e4d01d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_ff5ff9a4 === 'function') {
    await nuxt_plugin_workbox_ff5ff9a4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_63423c41 === 'function') {
    await nuxt_plugin_metaplugin_63423c41(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_144e0d74 === 'function') {
    await nuxt_plugin_moment_144e0d74(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_0c042044 === 'function') {
    await nuxt_plugin_datepicker_0c042044(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lightGalleryclient_235dd9a0 === 'function') {
    await nuxt_plugin_lightGalleryclient_235dd9a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cartState_10e8b97c === 'function') {
    await nuxt_plugin_cartState_10e8b97c(app.context, inject)
  }

  if (typeof nuxt_plugin_persistedState_1da1c1a3 === 'function') {
    await nuxt_plugin_persistedState_1da1c1a3(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_3b4804c9 === 'function') {
    await nuxt_plugin_filter_3b4804c9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouch_737c6982 === 'function') {
    await nuxt_plugin_vuetouch_737c6982(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pusher_4253ec9a === 'function') {
    await nuxt_plugin_pusher_4253ec9a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_354d424e === 'function') {
    await nuxt_plugin_plugin_354d424e(app.context, inject)
  }

  if (typeof nuxt_plugin_authredirect_4c47342c === 'function') {
    await nuxt_plugin_authredirect_4c47342c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
